import React from "react";
import { FastField } from "formik";
import TextField from "@mui/material/TextField";

export default function NumberInput({ name, ...props }) {
  return (
    <FastField name={name}>
      {({ field, form, meta }) => {
        const error = (meta.touched || form.submitCount > 0) && meta.error;
        
        return (
          <TextField
            {...field}
            {...props}
            size="small"
            type="number"
            variant="outlined"
            autoComplete="off"
            error={!!error}
            helperText={error}
            value={field.value ?? ""}
            onChange={(event) => {
              const value = event.target.value === "" ? "" : Number(event.target.value);
              form.setFieldValue(name, value);
            }}
          />
        );
      }}
    </FastField>
  );
}